export default "__VITE_ASSET__BlKn$SGG__"